(function () {
  'use strict';

  var node = document.getElementById('CaliGiftConfig');
  var cfg;
  try { cfg = JSON.parse(node && node.textContent); } catch (error) { return; }
  if (!cfg || !cfg.config || cfg.config.v !== 1) return;

  var M = cfg.messages || {};
  var KEY = 'cali_gift_selection_v1';
  var state = { cart: null, cartToken: '', offer: null, rememberedOfferId: '', variants: [], code: '', draftCode: '', campaignCode: '', variantId: '', busy: false, action: '', phase: '', actionTarget: '', suppressed: false, error: '', errorSource: '', pending: null, upcoming: '', lastResolveSignature: '', lastValidatedAt: 0, lastAutoSignature: '', lastAttemptSignature: '', failedCode: '', focusTarget: '', focusWidget: null };
  var resolveSeq = 0;
  var reconcileTimer = null;
  var VALIDATION_TTL = 60000;
  var checkoutReplay = false;

  function saved() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (error) { return {}; }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify({ suppressed: state.suppressed, cartToken: (state.cart && state.cart.token) || state.cartToken })); } catch (error) {}
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function endpoint(path) { return root().replace(/\/$/, '/') + path; }
  function post(path, body) {
    return fetch(endpoint(path), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (response) { return response.json().then(function (value) { if (!response.ok) throw new Error(value.description || value.message || 'Cart error'); return value; }); });
  }
  function cartRead() {
    var sync = window.caliCartSync;
    return sync && sync.getCart ? sync.getCart() : fetch(endpoint('cart.js'), { cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function variantNumber(id) { return String(id || '').replace(/^gid:\/\/shopify\/ProductVariant\//, ''); }
  function sameId(a, b) { return String(a || '').replace(/\D/g, '') === String(b || '').replace(/\D/g, ''); }
  function tagged(item) { return !!(item && item.properties && item.properties._cali_gift_offer); }
  function giftLines(cart) { return (cart.items || []).filter(tagged); }
  function sameGiftLine(a, b) {
    return !!(a && b && a.properties._cali_gift_offer === b.properties._cali_gift_offer &&
      a.properties._cali_gift_code === b.properties._cali_gift_code && sameId(a.variant_id, b.variant_id) && sameId(a.product_id, b.product_id));
  }
  function sameGiftLines(observed, current) {
    return observed.length === current.length && observed.every(function (line, index) { return sameGiftLine(line, current[index]); });
  }
  function paidItems(cart) {
    var valid = typeof getCartValidationResults === 'function' ? getCartValidationResults(cart.items || []).validItems : cart.items || [];
    return valid.filter(function (item) {
      var props = item.properties || {};
      return !tagged(item) && props._bundleType !== 'child' && !props._cali_sp && !item.gift_card && !(item.handle && item.handle.indexOf('navidium-shipping-protection') !== -1) && !(typeof item.sku === 'string' && item.sku.toUpperCase().indexOf('NVDPROTECTION') === 0) && item.original_line_price > 0;
    });
  }
  function eligible(cart, offer) {
    var items = paidItems(cart);
    if (!items.length) return false;
    return true;
  }
  function codes(cart) {
    if (!Array.isArray(cart.discount_codes)) return [];
    return cart.discount_codes.map(function (entry) { return typeof entry === 'string' ? entry : entry.code; }).filter(Boolean);
  }
  function discountAmount(cart, code, productId) {
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      if (!sameId(item.product_id, productId)) return;
      (item.line_level_discount_allocations || []).forEach(function (entry) {
        var app = entry.discount_application || {};
        if (String(app.code || app.title || '').toUpperCase() === String(code).toUpperCase()) sum += Number(entry.amount) || 0;
      });
    });
    return sum;
  }
  function moneyOffCodes(cart) {
    var found = [];
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (entry) {
        var app = entry.discount_application || {};
        var code = app.code || app.title;
        if (app.type === 'discount_code' && code && found.indexOf(code) === -1) found.push(code);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      var code = app.code || app.title;
      if (app.type === 'discount_code' && app.target_type !== 'shipping_line' && code && found.indexOf(code) === -1) found.push(code);
    });
    return found;
  }
  function nativeDiscountConfirmed(cart, offer, code) {
    var lines = giftLines(cart).filter(function (item) { return item.properties._cali_gift_offer === offer.id; });
    if (lines.length !== 1 || lines[0].quantity !== 1) return false;
    return discountAmount(cart, code || offer.applied_discount_code, offer.gift_product_id) >= (lines[0].original_price || 1);
  }
  function resolve(args) {
    var ownedLine = state.cart && giftLines(state.cart)[0];
    var ownedCode = ownedLine && ownedLine.properties._cali_gift_code;
    var summary = state.cart ? paidItems(state.cart).map(function (item) {
      var paidMinor = item.final_line_price;
      if (ownedLine && ownedCode && sameId(item.product_id, ownedLine.product_id)) {
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          var app = allocation.discount_application || {};
          if (String(app.code || app.title || '').toUpperCase() === String(ownedCode).toUpperCase()) paidMinor += Number(allocation.amount) || 0;
        });
      }
      return { product_id: String(item.product_id), quantity: item.quantity, final_line_price: paidMinor };
    }) : [];
    return fetch('https://labomono.vercel.app/api/gift-offers/resolve', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ code: args.code || undefined, offer_id: args.offer_id || undefined, country: cfg.country, locale: cfg.locale, cart: { currency: state.cart && state.cart.currency, items: summary } }) })
      .then(function (response) { if (!response.ok) throw new Error('Resolve unavailable'); return response.json(); });
  }
  function messageFor(result) {
    if (result.status === 'not_found') return M.invalid;
    if (result.status === 'unavailable') return M.unavailable;
    if (result.eligibility && result.eligibility.reason === 'expired') return M.expired;
    if (result.offer && result.eligibility && result.eligibility.reason === 'min_spend' && state.cart && result.eligibility.currency_code === state.cart.currency) {
      var remaining = Number(result.eligibility.remaining_minor) || 0;
      if (remaining > 0) return M.progress.replace('[remaining]', window.caliCartSync ? window.caliCartSync.formatCents(remaining) : (remaining / 100).toFixed(2));
    }
    return M.ineligible;
  }
  function mountGiftRows() {
    if (!window.document || !window.document.body) return;
    var line = state.cart && giftLines(state.cart)[0];
    document.querySelectorAll('[data-cali-gift-line]').forEach(function (row) {
      var controls = row.querySelector('[data-cali-gift-row-controls]');
      if (!controls) return;
      var managed = !!(line && !state.suppressed && row.dataset.caliGiftLine === line.properties._cali_gift_offer);
      if (!managed) {
        if (controls.childNodes.length) controls.replaceChildren();
        delete controls.dataset.giftSignature;
        row.classList.remove('cali-gift-row--managed');
        row.classList.remove('cali-gift-row--has-select');
        return;
      }
      var selectedId = row.dataset.caliGiftVariantId || line.variant_id;
      var signature = [String(selectedId), state.offer && state.offer.id, state.variants.map(function (v) { return [v.id, v.title, v.available].join(':'); }).join('|'), state.busy, state.action, state.actionTarget, state.error].join('|');
      if (controls.dataset.giftSignature === signature) return;
      var focused = document.activeElement;
      var restoreFocus = controls.contains(focused) ? (focused.dataset.giftRemove ? 'remove' : 'variant') : '';
      controls.replaceChildren();
      controls.dataset.giftSignature = signature;
      row.classList.add('cali-gift-row--managed');
      row.classList.toggle('cali-gift-row--has-select', state.variants.length > 1);
      if (state.variants.length > 1) {
        var label = document.createElement('label');
        label.className = 'cali-gift-row__colour';
        var caption = document.createElement('span'); caption.textContent = row.dataset.caliGiftOptionLabel || M.choose_colour; label.appendChild(caption);
        var select = document.createElement('select'); select.dataset.giftVariantSelect = '1'; select.setAttribute('aria-label', M.choose_colour);
        select.setAttribute('aria-busy', String(state.busy && state.action === 'colour'));
        select.disabled = state.busy;
        state.variants.forEach(function (variant) {
          var option = document.createElement('option'); option.value = variant.id; option.textContent = variant.title;
          option.disabled = !variant.available; option.selected = sameId(selectedId, variant.id);
          select.appendChild(option);
        });
        label.appendChild(select); controls.appendChild(label);
      }
      var remove = document.createElement('button'); remove.type = 'button'; remove.dataset.giftRemove = '1';
      remove.disabled = state.busy || !state.offer; remove.setAttribute('aria-busy', String(state.busy && state.action === 'remove'));
      remove.textContent = row.dataset.caliGiftRemoveText || M.remove; remove.setAttribute('aria-label', M.remove); controls.appendChild(remove);
      if (state.error && state.errorSource === 'row') {
        var error = document.createElement('span'); error.className = 'cali-gift-row__error'; error.setAttribute('role', 'alert'); error.textContent = state.error; controls.appendChild(error);
      }
      if (restoreFocus && !state.busy) {
        var target = restoreFocus === 'variant' ? select : remove;
        if (target && !target.disabled) target.focus({ preventScroll: true });
      }
      if (!state.busy && state.focusTarget === 'variant' && sameId(selectedId, line.variant_id) && select) {
        select.focus({ preventScroll: true }); state.focusTarget = ''; state.focusWidget = null;
      }
      if (!state.busy && state.focusTarget === 'remove' && sameId(selectedId, line.variant_id)) {
        remove.focus({ preventScroll: true }); state.focusTarget = ''; state.focusWidget = null;
      }
    });
  }
  function render() {
    var line = state.cart && giftLines(state.cart)[0];
    mountGiftRows();
    document.querySelectorAll('[data-cali-gift]').forEach(function (widget) {
      var reveal = widget.querySelector('[data-cali-gift-reveal]');
      var form = widget.querySelector('[data-cali-gift-form]');
      var input = widget.querySelector('[data-cali-gift-code]');
      var offerBox = widget.querySelector('[data-cali-gift-offer]');
      var status = widget.querySelector('[data-cali-gift-status]');
      var progress = widget.querySelector('[data-cali-gift-progress]');
      var codeError = !!state.error && state.errorSource !== 'row';
      var open = widget.dataset.open === '1' || codeError || (!!state.draftCode && !state.offer);
      var focused = document.activeElement;
      var closingFocusedForm = !open && form.contains(focused);
      reveal.setAttribute('aria-expanded', String(open));
      widget.setAttribute('aria-busy', String(state.busy));
      form.hidden = !open;
      if (input && document.activeElement !== input) input.value = state.draftCode || '';
      var apply = widget.querySelector('[data-cali-gift-apply]');
      apply.disabled = state.busy;
      apply.setAttribute('aria-busy', String(state.busy && state.action === 'apply'));
      offerBox.replaceChildren();
      offerBox.hidden = !state.pending;
      if (state.pending) {
        var warning = document.createElement('p'); warning.textContent = M.replace_discount; offerBox.appendChild(warning);
        state.pending.choices.forEach(function (code) { var confirm = document.createElement('button'); confirm.type = 'button'; confirm.dataset.giftConfirm = code; confirm.textContent = M.replace + ' ' + code; offerBox.appendChild(confirm); });
        var cancel = document.createElement('button'); cancel.type = 'button'; cancel.dataset.giftCancel = '1'; cancel.textContent = M.cancel; offerBox.appendChild(cancel);
      }
      var busyMessage = state.action === 'remove' ? (M.removing || '') : (state.action === 'colour' ? (M.updating || M.loading) : (state.phase === 'add' || state.action === 'add' ? (M.adding || M.loading) : (state.action === 'apply' ? M.loading : '')));
      status.textContent = codeError ? state.error : (state.busy ? (busyMessage || '') : (state.action === 'removed' ? (M.removed || '') : ''));
      status.classList.toggle('cali-gift__status--error', codeError);
      status.classList.toggle('cali-gift__status--removed', state.action === 'removed');
      status.classList.toggle('cali-gift__status--confirmed', false);
      input.setAttribute('aria-invalid', String(codeError && open));
      if (codeError && open) input.setAttribute('aria-describedby', status.id);
      else input.removeAttribute('aria-describedby');
      if (progress) { progress.textContent = state.upcoming || ''; progress.hidden = !state.upcoming; }
      if (!state.busy && closingFocusedForm) {
        var next = document.querySelector('[data-cali-gift-row-controls] [data-gift-variant-select]') || document.querySelector('[data-cali-gift-row-controls] [data-gift-remove]') || reveal;
        if (next === reveal && line && state.offer) state.focusTarget = state.variants.length > 1 ? 'variant' : 'remove';
        if (!next.disabled) next.focus({ preventScroll: true });
      }
    });
    if (!state.busy && state.focusTarget === 'remove') {
      var target = document.querySelector('[data-cali-gift-row-controls] [data-gift-remove]') || ((!line || !state.offer) && document.querySelector('[data-cali-gift-reveal]'));
      if (target && !target.disabled && (document.activeElement === document.body || !document.activeElement || !document.activeElement.isConnected)) target.focus({ preventScroll: true });
      if (target) { state.focusTarget = ''; state.focusWidget = null; }
    }
  }
  function runExclusive(fn) {
    var work = function () { return (window.caliCartSync && window.caliCartSync.runMutation) ? window.caliCartSync.runMutation(fn) : fn(); };
    return navigator.locks && navigator.locks.request ? navigator.locks.request('cali-gift-cart', work) : work();
  }
  function removeTagged(cart) {
    if (!cart) return cartRead().then(removeTagged);
    var lines = giftLines(cart); if (!lines.length) return Promise.resolve(cart);
    var updates = {}; lines.forEach(function (item) { updates[item.key] = 0; });
    return post('cart/update.js', { updates: updates });
  }
  function removeGiftAndCode(ownedOverride, cart) {
    if (!cart) return cartRead().then(function (fresh) { return removeGiftAndCode(ownedOverride, fresh); });
      var lines = giftLines(cart);
      var ownedCodes = lines.map(function (line) { return line.properties._cali_gift_code; }).filter(Boolean);
      if (ownedOverride) ownedCodes.push(ownedOverride);
      if (state.offer && state.offer.applied_discount_code) ownedCodes.push(state.offer.applied_discount_code);
      var remaining = codes(cart).filter(function (code) { return !ownedCodes.some(function (owned) { return code.toUpperCase() === owned.toUpperCase(); }); });
      var body = {};
      if (lines.length) { body.updates = {}; lines.forEach(function (line) { body.updates[line.key] = 0; }); }
      if (ownedCodes.length && remaining.length !== codes(cart).length) body.discount = remaining.join(',');
      return Object.keys(body).length ? post('cart/update.js', body) : cart;
  }
  function cleanupGift(reason, ownedOverride, cause) {
    if (state.busy) return;
    var removing = state.action === 'remove';
    var observed = giftLines(state.cart || {});
    var hadNoPaidItems = !paidItems(state.cart || {}).length;
    state.busy = true; state.action = removing ? 'remove' : 'cleanup'; state.error = reason || ''; state.errorSource = reason ? 'code' : ''; render();
    runExclusive(function () { return cartRead().then(function (cart) {
      var current = giftLines(cart);
      var nowConfirmed = cause === 'discount' && current.length === 1 &&
        nativeDiscountConfirmed(cart, { id: current[0].properties._cali_gift_offer, gift_product_id: current[0].product_id }, current[0].properties._cali_gift_code);
      // An earlier cart event may have described the cart between remove/add or
      // before Shopify's allocation settled. Never apply that cleanup to a
      // different, or now-confirmed, gift after the cart lock becomes available.
      if (!sameGiftLines(observed, current) || (!removing && nowConfirmed) || (!removing && hadNoPaidItems && paidItems(cart).length)) return { cart: cart, skipped: true };
      return removeGiftAndCode(ownedOverride, cart).then(function (updated) { return { cart: updated, skipped: false }; });
    }); }).then(function (result) {
      var cart = result.cart;
      state.cart = cart;
      if (result.skipped) {
        state.offer = null; state.variants = []; state.variantId = ''; state.code = ''; state.draftCode = '';
        state.suppressed = false; state.error = ''; state.errorSource = ''; state.action = ''; state.lastResolveSignature = ''; save();
        state.busy = false; state.phase = ''; render(); reconcile(cart); return;
      }
      if (removing) { state.offer = null; state.variants = []; state.variantId = ''; state.code = ''; state.draftCode = ''; state.campaignCode = ''; state.suppressed = true; state.action = 'removed'; save(); }
      state.busy = false; state.phase = ''; if (!removing) state.action = ''; render(); reconcile(cart);
    }, function () { state.busy = false; state.action = ''; state.phase = ''; state.error = M.discount_failed; state.errorSource = removing ? 'row' : 'code'; render(); });
  }
  function applyDiscount(code, prior) {
    var all = prior.filter(function (other) { return other.toUpperCase() !== code.toUpperCase(); }); all.push(code);
    return post('cart/update.js', { discount: all.join(',') });
  }
  function transact(offer, variants, variantId, code, replaceCode) {
    if (state.busy) return Promise.resolve(false);
    state.busy = true; state.error = ''; state.errorSource = ''; if (!state.action) state.action = offer.kind === 'code' ? 'apply' : 'add'; if (!state.phase) state.phase = state.action === 'apply' ? 'resolve' : 'add'; render();
    var before, priorCodes, priorLine, added = false, removed = false, rollbackConfirmed = false, proposedCodes = [];
    return runExclusive(function () {
      return cartRead().then(function (cart) {
        before = cart; priorCodes = codes(cart); priorLine = giftLines(cart)[0];
        if (!eligible(cart, offer)) throw new Error(M.ineligible);
        if (offer.kind === 'automatic' && priorLine) {
          var priorKind = priorLine.properties._cali_gift_kind;
          var priorInPublic = (cfg.config.offers || []).some(function (entry) { return entry.id === priorLine.properties._cali_gift_offer && entry.kind === 'automatic'; });
          if (priorKind === 'code' || (!priorKind && !priorInPublic)) throw new Error('manual_priority');
          var existingOffer = (cfg.config.offers || []).find(function (entry) { return entry.id === priorLine.properties._cali_gift_offer; });
          if (existingOffer && existingOffer.priority >= offer.priority) throw new Error('higher_priority');
        }
        var oldCode = priorLine && priorLine.properties._cali_gift_code;
        proposedCodes = priorCodes.filter(function (other) { return (!oldCode || other.toUpperCase() !== oldCode.toUpperCase()) && (!replaceCode || other.toUpperCase() !== replaceCode.toUpperCase()); });
        return removeTagged(cart).then(function (cart) { removed = true; return cart; });
      }).then(function () {
        return post('cart/add.js', { id: Number(variantNumber(variantId)), quantity: 1, properties: { _cali_gift_offer: offer.id, _cali_gift_code: code || '', _cali_gift_kind: offer.kind } });
      }).then(function () {
        added = true;
        return applyDiscount(code, proposedCodes);
      }).then(function (cart) {
        if (nativeDiscountConfirmed(cart, offer, code)) return cart;
        return cartRead().then(function (fresh) {
          if (!nativeDiscountConfirmed(fresh, offer, code)) throw new Error(M.discount_failed);
          return fresh;
        });
      }).then(function (cart) {
        state.cart = cart; state.offer = offer; state.rememberedOfferId = offer.id; state.variants = variants; state.code = offer.kind === 'code' ? (offer.code || code) : ''; state.draftCode = ''; state.campaignCode = ''; state.variantId = variantId; state.suppressed = false; state.pending = null; document.querySelectorAll('[data-cali-gift]').forEach(function (widget) { widget.dataset.open = '0'; }); if (offer.kind === 'code') state.upcoming = ''; state.lastValidatedAt = Date.now(); state.lastResolveSignature = paidSignature(cart); save(); return true;
      }).catch(function (error) {
        if (!removed) throw error;
        return (added ? removeTagged() : Promise.resolve()).then(function () {
          if (priorLine) return post('cart/add.js', { id: priorLine.variant_id, quantity: 1, properties: priorLine.properties });
        }).then(function () {
          if (priorCodes) return post('cart/update.js', { discount: priorCodes.join(',') });
        }).catch(function () {}).then(function () { return cartRead().catch(function () { return null; }); }).then(function (restored) {
          state.cart = restored;
          var oldCode = priorLine && priorLine.properties._cali_gift_code;
          var oldLines = restored && giftLines(restored).filter(function (line) {
            return priorLine && line.properties._cali_gift_offer === priorLine.properties._cali_gift_offer && sameId(line.variant_id, priorLine.variant_id) && line.properties._cali_gift_code === oldCode;
          });
          rollbackConfirmed = priorLine ? !!(oldLines && oldLines.length === 1 && oldLines[0].quantity === 1 && discountAmount(restored, oldCode, priorLine.product_id) >= (oldLines[0].original_price || 1)) : !!(restored && !giftLines(restored).length);
          if (rollbackConfirmed) return;
          return removeGiftAndCode(oldCode).catch(function () {}).then(function () { return cartRead().catch(function () { return null; }); }).then(function (fresh) { state.cart = fresh; });
        }).then(function () { throw rollbackConfirmed ? error : new Error(M.discount_failed); });
      });
    }).then(function () { state.busy = false; state.action = ''; state.phase = ''; state.actionTarget = ''; render(); return true; }, function (error) {
      var failedAction = state.action;
      state.busy = false; state.action = ''; state.phase = ''; state.actionTarget = '';
      if (removed && !rollbackConfirmed) {
        state.offer = null; state.variants = []; state.variantId = ''; state.code = ''; state.draftCode = ''; state.pending = null; state.upcoming = ''; state.suppressed = false; save();
      }
      if (rollbackConfirmed && error.message === M.discount_failed && !replaceCode && priorCodes && priorCodes.length) {
        var oldCode = priorLine && priorLine.properties._cali_gift_code;
        var merchandiseCodes = moneyOffCodes(before);
        var choices = priorCodes.filter(function (other) { return merchandiseCodes.some(function (moneyCode) { return moneyCode.toUpperCase() === other.toUpperCase(); }) && other.toUpperCase() !== String(oldCode || '').toUpperCase() && other.toUpperCase() !== String(code).toUpperCase(); });
        if (choices.length) state.pending = { offer: offer, variants: variants, variantId: variantId, code: code, choices: choices };
      }
      if (offer.kind === 'code') state.failedCode = offer.code || code;
      if (!state.pending && error.message !== 'manual_priority' && error.message !== 'higher_priority') { state.error = priorLine && rollbackConfirmed ? M.colour_failed : (error.message || M.discount_failed); state.errorSource = failedAction === 'colour' && rollbackConfirmed ? 'row' : 'code'; }
      render(); return false;
    });
  }
  function offerFromResolve(result, code) {
    if (!result || result.status !== 'eligible' || !result.offer || (result.eligibility && !result.eligibility.eligible)) { state.error = messageFor(result || {}); state.lastAttemptSignature = state.cart ? paidSignature(state.cart) : ''; if (result && result.status === 'not_found') state.failedCode = code || ''; render(); return; }
    var offer = result.offer;
    var variants = (result.variants || []).filter(function (v) { return offer.allowed_variant_ids.some(function (id) { return sameId(id, v.id); }); });
    var preferred = ((state.offer && state.offer.id === offer.id) || state.rememberedOfferId === offer.id) && variants.find(function (v) { return sameId(v.id, state.variantId) && v.available; });
    if (!preferred) preferred = variants.find(function (v) { return sameId(v.id, offer.default_variant_id) && v.available; });
    if (!preferred) (offer.fallback_variant_ids || []).some(function (id) { preferred = variants.find(function (v) { return sameId(v.id, id) && v.available; }); return !!preferred; });
    if (!preferred) preferred = variants.find(function (v) { return v.available; });
    if (!preferred) { state.error = M.unavailable; render(); return; }
    var exact = offer.applied_discount_code || offer.code || code || '';
    if (!state.cart || !eligible(state.cart, offer)) { state.error = M.ineligible; render(); return; }
    transact(offer, variants, preferred.id, exact);
  }
  function applyCode(code, fromCampaign) {
    code = String(code || '').trim(); if (!code || state.busy) return;
    state.error = ''; state.errorSource = ''; state.failedCode = ''; state.draftCode = fromCampaign ? '' : code; state.busy = true; state.action = 'apply'; state.phase = 'resolve'; save(); render();
    var seq = ++resolveSeq;
    resolve({ code: code }).then(function (result) {
      if (seq !== resolveSeq) return;
      if (fromCampaign && (!result || result.status !== 'eligible')) {
        if (!result || result.status !== 'ineligible') state.campaignCode = '';
        state.lastAttemptSignature = state.cart ? paidSignature(state.cart) : '';
      }
      if (result && result.status === 'eligible' && result.offer && (!result.eligibility || result.eligibility.eligible)) { state.busy = false; state.phase = 'add'; offerFromResolve(result, code); if (!state.busy) { state.action = ''; state.phase = ''; render(); } }
      else { state.busy = false; state.action = ''; state.phase = ''; offerFromResolve(result, code); }
    }, function () { if (fromCampaign) state.campaignCode = ''; state.busy = false; state.action = ''; state.phase = ''; state.error = M.discount_failed; render(); });
  }
  function paidSignature(cart) {
    return paidItems(cart).map(function (item) { return [item.key, item.product_id, item.quantity, item.final_line_price].join(':'); }).sort().join('|');
  }
  function checkTagged(cart, line, signature) {
    state.busy = true; render();
    var publicAutomatic = (cfg.config.offers || []).some(function (offer) { return offer.id === line.properties._cali_gift_offer && offer.kind === 'automatic'; });
    var args = line.properties._cali_gift_kind === 'automatic' || (!line.properties._cali_gift_kind && publicAutomatic) ? { offer_id: line.properties._cali_gift_offer } : { code: line.properties._cali_gift_code };
    resolve(args).then(function (result) {
      state.busy = false;
      if (paidSignature(state.cart) !== signature || !sameGiftLine(giftLines(state.cart)[0], line)) {
        state.offer = null; state.variants = []; state.variantId = ''; state.code = ''; state.lastResolveSignature = ''; reconcile(state.cart); return;
      }
      if (!result || result.status !== 'eligible' || !result.offer || (result.eligibility && !result.eligibility.eligible)) {
        state.lastAttemptSignature = signature; state.offer = null; state.lastAutoSignature = ''; cleanupGift(messageFor(result || {}), null, 'resolver'); return;
      }
      var offer = result.offer;
      var variants = (result.variants || []).filter(function (variant) { return offer.allowed_variant_ids.some(function (id) { return sameId(id, variant.id); }); });
      var selected = variants.find(function (variant) { return sameId(variant.id, line.variant_id) && variant.available; });
      if (!selected) { offerFromResolve(result, offer.code || ''); return; }
      if (!nativeDiscountConfirmed(state.cart, offer, offer.applied_discount_code)) {
        state.lastAttemptSignature = signature; state.offer = null; state.lastAutoSignature = ''; cleanupGift(M.discount_failed, null, 'discount'); return;
      }
      state.offer = offer; state.rememberedOfferId = offer.id; state.variants = variants; state.variantId = selected.id; state.code = offer.kind === 'code' ? offer.code : ''; state.error = ''; state.lastValidatedAt = Date.now(); save(); render();
      if (offer.kind === 'automatic' && cfg.config.offers && cfg.config.offers.length && state.lastAutoSignature !== signature) {
        state.lastAutoSignature = signature; state.upcoming = '';
        tryAutomatic(state.cart, signature, cfg.config.offers.filter(function (item) { return item.kind === 'automatic'; }).sort(function (a, b) { return b.priority - a.priority; }), 0);
      }
    }, function () {
      state.busy = false;
      if (paidSignature(state.cart) !== signature || !sameGiftLine(giftLines(state.cart)[0], line)) {
        state.offer = null; state.variants = []; state.variantId = ''; state.code = ''; state.lastResolveSignature = ''; reconcile(state.cart); return;
      }
      state.lastAttemptSignature = signature; state.offer = null; state.lastAutoSignature = ''; cleanupGift(M.discount_failed, null, 'resolver');
    });
  }
  function tryAutomatic(cart, signature, offers, index) {
    if (index >= offers.length || state.busy || state.suppressed || state.code || state.draftCode) return;
    var candidate = offers[index];
    resolve({ offer_id: candidate.id }).then(function (result) {
      if (paidSignature(state.cart) !== signature) return;
      if (result && result.status === 'eligible' && result.offer && (!result.eligibility || result.eligibility.eligible)) {
        if (state.offer && state.offer.id === result.offer.id && giftLines(state.cart).length) return;
        offerFromResolve(result, '');
      } else {
        if (!state.upcoming && result && result.eligibility && result.eligibility.reason === 'min_spend') {
          var progress = messageFor(result);
          if (progress !== M.ineligible) { state.upcoming = progress; render(); }
        }
        tryAutomatic(cart, signature, offers, index + 1);
      }
    }, function () { state.error = M.discount_failed; render(); });
  }
  function reconcile(cart) {
    if (!cart || !cart.items) return;
    state.cart = cart;
    var remembered = saved();
    state.cartToken = cart.token || '';
    if (!remembered.cartToken || !cart.token || remembered.cartToken !== cart.token) { state.suppressed = false; state.code = ''; state.draftCode = ''; state.offer = null; state.rememberedOfferId = ''; state.variantId = ''; save(); }
    if (state.busy) { render(); return; }
    var lines = giftLines(cart), taggedLine = lines[0], signature = paidSignature(cart);
    if (!paidItems(cart).length) {
      if (taggedLine) { state.offer = null; cleanupGift(M.ineligible, null, 'missingPaid'); }
      else { state.suppressed = false; save(); render(); }
      return;
    }
    if (state.campaignCode && !state.suppressed && state.lastAttemptSignature !== signature) {
      state.lastAttemptSignature = signature;
      applyCode(state.campaignCode, true);
      return;
    }
    if (lines.length > 1 || (taggedLine && state.suppressed)) {
      state.offer = null; cleanupGift(M.discount_failed); return;
    }
    if (taggedLine) {
      if (state.offer && state.offer.id === taggedLine.properties._cali_gift_offer && !nativeDiscountConfirmed(cart, state.offer, state.offer.applied_discount_code)) {
        state.lastAttemptSignature = signature; state.offer = null; state.lastAutoSignature = ''; cleanupGift(M.discount_failed, null, 'discount'); return;
      }
      if (signature !== state.lastResolveSignature || !state.offer || state.offer.id !== taggedLine.properties._cali_gift_offer || Date.now() - state.lastValidatedAt > VALIDATION_TTL) {
        state.lastResolveSignature = signature;
        checkTagged(cart, taggedLine, signature);
      } else render();
      return;
    }
    if (state.offer) { var ownedCode = state.offer.applied_discount_code; state.suppressed = true; state.offer = null; state.code = ''; state.draftCode = ''; state.variants = []; state.variantId = ''; save(); cleanupGift('', ownedCode); return; }
    render();
    if (state.suppressed) return;
    var code = state.draftCode || state.code;
    if (code && code !== state.failedCode && (signature !== state.lastAttemptSignature || Date.now() - state.lastValidatedAt > VALIDATION_TTL)) {
      if (reconcileTimer) clearTimeout(reconcileTimer);
      state.lastAttemptSignature = signature;
      reconcileTimer = setTimeout(function () { if (!state.busy) applyCode(code); }, 400);
      return;
    }
    if (!code && signature !== state.lastAutoSignature && cfg.config.offers && cfg.config.offers.length) {
      state.lastAutoSignature = signature; state.upcoming = '';
      var automatic = cfg.config.offers.filter(function (offer) { return offer.kind === 'automatic'; }).sort(function (a, b) { return b.priority - a.priority; });
      tryAutomatic(cart, signature, automatic, 0);
    }
  }

  if (!cfg.config.enabled) {
    try { localStorage.removeItem(KEY); } catch (error) {}
    var disabledBusy = false;
    function disabledReconcile(cart) {
      if (!cart || !cart.items || disabledBusy || !giftLines(cart).length) return;
      state.cart = cart; disabledBusy = true;
      runExclusive(function () { return removeGiftAndCode(); }).then(function () { disabledBusy = false; }, function () { disabledBusy = false; });
    }
    document.addEventListener('cali:cart', function (event) { disabledReconcile(event.detail && event.detail.cart); });
    cartRead().then(disabledReconcile, function () {});
    window.addEventListener('focus', function () { cartRead().then(disabledReconcile, function () {}); });
    return;
  }
  var initial = saved(); state.cartToken = initial.cartToken || ''; state.rememberedOfferId = ''; state.variantId = ''; state.suppressed = !!initial.cartToken && !!initial.suppressed; save();
  try {
    var giftUrl = new URL(location.href), param = giftUrl.searchParams.get('gift');
    if (param) {
      state.campaignCode = param.trim(); state.suppressed = false; save();
      giftUrl.searchParams.delete('gift'); history.replaceState(history.state, '', giftUrl.pathname + giftUrl.search + giftUrl.hash);
    }
  } catch (error) {}
  document.addEventListener('cali:cart', function (event) { reconcile(event.detail && event.detail.cart); });
  // Motion replaces cart item markup after its asynchronous section fetch. Reattach
  // controls to the new native row; an unchanged mount performs no DOM writes.
  new MutationObserver(function () { mountGiftRows(); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cali-gift-reveal], [data-cali-gift-apply], [data-gift-remove], [data-gift-confirm], [data-gift-cancel]'); if (!button) return;
    var widget = button.closest('[data-cali-gift]');
    if (!widget && !button.closest('[data-cali-gift-line]')) return;
    // Motion's window click handler closes the drawer when its target has
    // already been detached by render(). Keep gift controls inside this UI.
    event.stopPropagation();
    if (button.hasAttribute('data-cali-gift-reveal')) { widget.dataset.open = '1'; render(); widget.querySelector('[data-cali-gift-code]').focus(); return; }
    if (button.hasAttribute('data-cali-gift-apply')) { applyCode(widget.querySelector('[data-cali-gift-code]').value); return; }
    if (button.hasAttribute('data-gift-confirm') && state.pending) { var pending = state.pending; state.pending = null; transact(pending.offer, pending.variants, pending.variantId, pending.code, button.dataset.giftConfirm); return; }
    if (button.hasAttribute('data-gift-cancel')) { state.pending = null; render(); return; }
    if (button.hasAttribute('data-gift-remove')) {
      if (state.busy || !state.offer) return;
      if (document.activeElement === button) state.focusTarget = 'remove';
      state.action = 'remove'; cleanupGift('');
    }
  });
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-gift-variant-select]');
    if (!select || !select.closest('[data-cali-gift-line]') || !state.offer || state.busy) return;
    var variant = state.variants.find(function (entry) { return sameId(entry.id, select.value) && entry.available; });
    if (!variant || sameId(select.closest('[data-cali-gift-line]').dataset.caliGiftVariantId, variant.id)) return;
    state.focusTarget = 'variant'; state.action = 'colour'; state.actionTarget = variant.id;
    transact(state.offer, state.variants, variant.id, state.offer.applied_discount_code);
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-cali-gift-code]')) { event.preventDefault(); applyCode(event.target.value); } });
  window.addEventListener('storage', function (event) { if (event.key !== KEY) return; var value = saved(); state.cartToken = value.cartToken || ''; state.rememberedOfferId = ''; state.variantId = ''; state.suppressed = !!state.cartToken && !!value.suppressed; state.offer = null; state.code = ''; state.draftCode = ''; state.lastResolveSignature = ''; if (window.caliCartSync) window.caliCartSync.refresh(); });
  window.addEventListener('focus', function () { state.lastValidatedAt = 0; cartRead().then(reconcile, function () {}); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { state.lastValidatedAt = 0; cartRead().then(reconcile, function () {}); } });
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[name="checkout"], [data-checkout]');
    if (!button || checkoutReplay || !state.offer || !giftLines(state.cart || {}).length || Date.now() - state.lastValidatedAt <= VALIDATION_TTL) return;
    event.preventDefault(); event.stopImmediatePropagation();
    state.busy = true; render();
    cartRead().then(function (cart) {
      state.cart = cart;
      if (!nativeDiscountConfirmed(cart, state.offer, state.offer.applied_discount_code)) throw new Error(M.discount_failed);
      var line = giftLines(cart)[0];
      return resolve(line.properties._cali_gift_kind === 'automatic' ? { offer_id: line.properties._cali_gift_offer } : { code: line.properties._cali_gift_code });
    }).then(function (result) {
      if (!result || result.status !== 'eligible' || !result.offer || (result.eligibility && !result.eligibility.eligible)) throw new Error(messageFor(result || {}));
      state.lastValidatedAt = Date.now(); state.busy = false; render();
      checkoutReplay = true; button.click(); checkoutReplay = false;
    }).catch(function (error) { state.busy = false; state.error = error.message || M.discount_failed; render(); });
  }, true);
  render();
})();
